import React, { useState, useContext, useCallback } from 'react';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import InputControl from '../Input/InputControl';
import Input from '@material-ui/core/Input';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import Button from '~/components/Button';
import Avatar from '@material-ui/core/Avatar';

import Col from '../Col';

import getMe from '~/utils/getMe';
import useStyles from './styles';
import formatUserAccessType from '~/utils/formatUserAccessType';
import {useDispatch, useSelector} from 'react-redux';
import { signOut } from '~/store/modules/auth';
import { editUserProfileRequest } from '~/store/modules/userProfile';

import ProfileDrawerContext from '~/contexts/ProfileDrawerContext';

const AvatarComponent = () => {
  const reduxData = useSelector(state => state.userProfile.data || '');
  const classes = useStyles();
  const {name, access_type} = reduxData;
  return(
    //O BASE NAO TEM NENHUM UUSARIO QUE TENHA UM AVATAR, entao eh so mudar para os dados do redux para um cara que tenha avatar
    //MESMO caso no drawer de cima =)
    <div className={classes.avatar}>
      <Avatar
        alt={name}
        src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/7c/User_font_awesome.svg/1024px-User_font_awesome.svg.png"
        className={classes.large}
      />
      <div className={classes.textDivs}>
        <div>
          <a>{name}</a>
        </div>
        <a>{formatUserAccessType(access_type)}</a>
      </div>
    </div>
  );
}

const FormField = ({onClose, id}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const reduxData = useSelector(state => state.userProfile.data || '');
  const [values, setValues] = useState({
    name:  reduxData['name'],
    email: reduxData['email'],
    password: '',
  });
  const onSave = () => {
    dispatch(editUserProfileRequest(id, {data: values}));
    onClose();
  };
  const onChange = (attr) =>{
    setValues({...values, ...attr});
  }
  return(
    <React.Fragment>
      <div className={classes.formDiv}>
        <Field
          label={'Nome'}
          field={'name'}
          value={values['name']}
          onChange={onChange}
          />
        <Field
          label={'E-mail'}
          field={'email'}
          value={values['email']}
          onChange={onChange}
          />
        <Field
          label={'Alterar Senha'}
          field={'password'}
          value={values['password']}
          onChange={onChange}
          />
      </div>
      <FormButtons onClose={onClose} onSave={onSave}/>
    </React.Fragment>

  );
}

const Field = ({label, field, value, onChange}) => {
  return(
    <InputControl
      id={`id-${field}`}
      style={{alignSelf: 'center'}}
      value={value}
      name={field}
      label={label}
      inputComponent={Input}
      onChange={onChange}
    />
  );
}

const FormButtons = ({onClose, onSave}) => {
  const classes = useStyles();

  return(
    <Col className={classes.bottomButtons}>
      <Button
        color='success'
        size='small'
        variant='contained'
        onClick={onSave}
      >
        Salvar
      </Button>
      <Button
        size='small'
        className={classes.cancelButton}
        onClick={onClose}
      >
        Cancelar
      </Button>
    </Col>
  )
}


export default function SwipeableTemporaryDrawer() {
  const { id } = getMe();
  const dispatch = useDispatch();
  const classes = useStyles();
  const { profileOpen, setProfileDrawerOpen } = useContext(ProfileDrawerContext);

  const handleSignOut = useCallback(
    () => {
      dispatch(signOut())
      setProfileDrawerOpen(false);
    },
    [dispatch]
  );

  return (
    <SwipeableDrawer
      anchor={"right"}
      open={profileOpen}
      onClose={() => setProfileDrawerOpen(false)}
      onOpen={() => setProfileDrawerOpen(true)}
    >
      <div className={classes.list}>
        <AvatarComponent />
        <FormField id={id} onClose={() => {setProfileDrawerOpen(false)}} />

        <Button
          color="secondary"
          variant="text"
          className={classes.button}
          startIcon={<ExitToAppIcon />}
          onClick={handleSignOut}
        >
          Sair
        </Button>
      </div>
    </SwipeableDrawer>
  );
}
